import { render, staticRenderFns } from "./ErrorLicenseView.vue?vue&type=template&id=f2c5c7ce&scoped=true&"
import script from "./ErrorLicenseView.vue?vue&type=script&lang=ts&"
export * from "./ErrorLicenseView.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorLicenseView.vue?vue&type=style&index=0&id=f2c5c7ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c5c7ce",
  null
  
)

export default component.exports